window.app = window.app || {};

window.app.blogList = {
  el: document.querySelector('.mt-blog-list__carousel .swiper'),

  init: function() {
    const _this = this;
    if (!_this.el) return;

    _this.slider = new Swiper(_this.el, {
      slidesPerView: 'auto',
      spaceBetween: 24,
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 24
        },
        1000: {
          slidesPerView: 3,
          spaceBetween: 24
        },
        1100: {
          slidesPerView: 3,
          spaceBetween: 40
        }
      }
    });
  }
}
window.app.blogList.init();